module.exports = "<fw-page-header-bar [config]=\"pageHeaderConfig\"\r\n                    (btnClick)=\"phbBtnClicked($event)\">\r\n</fw-page-header-bar>\r\n\r\n<fw-dynamic-grid\r\n        #grid\r\n        [vmColumnDefinition]=\"columnDefinition\"\r\n        [rowKey]=\"'id'\"\r\n        (gridRowDoubleClick)=\"gridRowdoubleClicked($event)\">\r\n</fw-dynamic-grid>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/branches/branches-list/branches-list.component.html
// module id = 2509
// module chunks = 1